<template>
  <div class="page-wrapper">
    <TopBannerView v-if="isShowTopBanner" :banner="getTopBanner" />
    <main class="main">
      <AsideMenu />
      <div class='main-inner'>
        <AppHeader
          :is-mobile-menu-open="isMobileMenuOpen"
          @header-resize="closeMobileMenuOnResize"
        />
        <section class="content">
          <slot />
        </section>
        <AppFooter />
      </div>
      <MainBannerPopup ref="mainBanner" v-if="isMainBannerReady" :banner="getMainBanner" />
    </main>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { pages } from '@/entities/current-page';
import { MainBannerPopup, TopBannerView } from '@/features/advertise-banner';
import { AppFooter } from '@/widgets/app-footer';
import { AppHeader, HEADER_MOBILE_EVENTS } from '@/widgets/app-header';
import { AsideMenu, MOBILE_MENU_EVENTS } from '@/widgets/app-main-menu';

export default {
  data() {
    return {
      isMobileMenuOpen: false,
    };
  },
  created() {
    this.$eventBus.$on(HEADER_MOBILE_EVENTS.HEADER_MOBILE_MENU_TOGGLE, this.toggleMobileMenu);
    this.$eventBus.$on(MOBILE_MENU_EVENTS.MOBILE_MENU_CLOSE, () => this.toggleMobileMenu(false));

    if (this.getCurrentUser === null) {
      this.loadCurrentUser();
    }

    if (this.getActivePage === pages.HOME) {
      this.fetchTopBanner();
    }

    if (this.isShowMainBanner) {
      this.fetchMainBanner();
    }
  },
  beforeDestroy() {
    this.$eventBus.$off(HEADER_MOBILE_EVENTS.HEADER_MOBILE_MENU_TOGGLE, this.toggleMobileMenu);
    this.$eventBus.$off(MOBILE_MENU_EVENTS.MOBILE_MENU_CLOSE, () => this.toggleMobileMenu(false));
  },
  components: { AsideMenu, AppHeader, AppFooter, TopBannerView, MainBannerPopup },
  computed: {
    ...mapGetters('currentUserModule', ['getCurrentUser']),
    ...mapGetters('advertisementBannersModule', [
      'isShowMainBanner', 'getTopBanner', 'isTopBannerReady', 'getMainBanner', 'isMainBannerReady'
    ]),
    ...mapGetters('currentPageModule', ['getActivePage']),
    isShowTopBanner() {
      return this.getActivePage === pages.HOME && this.isTopBannerReady;
    },
  },
  methods: {
    ...mapActions('currentUserModule', ['loadCurrentUser']),
    ...mapActions('advertisementBannersModule', ['fetchTopBanner', 'fetchMainBanner', 'setMainBannerViewed']),
    toggleMobileMenu(isMenuOpen) {
      if (this.isMobileMenuOpen !== isMenuOpen) {
        this.isMobileMenuOpen = isMenuOpen;

        isMenuOpen
          ? this.$eventBus.$emit(MOBILE_MENU_EVENTS.MOBILE_MENU_OPEN)
          : this.$eventBus.$emit(MOBILE_MENU_EVENTS.MOBILE_MENU_CLOSE);
      }
    },
    closeMobileMenuOnResize({ isDesktop }) {
      if (isDesktop) {
        this.toggleMobileMenu(false);
      }
    },
  },
  watch: {
    isMainBannerReady(newValue) {
      if (newValue && this.isShowMainBanner) {
        setTimeout(() => {
          this.$refs.mainBanner.open();
          this.setMainBannerViewed(true);
        }, 1000);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/*@import '@/shared/styles/style';*/

.page-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
}

main.main {
  display: flex !important;
  min-height: 100vh !important;
  padding: 0 !important;
  margin: 0 !important;
}

.main-inner {
  display: flex !important;
  flex-direction: column !important;
  width: 100% !important;

  @media (min-width: 1050px) {
    margin-left: 151px;
  }
}

.content {
  flex-grow: 1 !important;
  padding: 24px 24px 24px !important;
}

@media (max-width: 1050px) {
  .content {
    padding-top: 24px !important;
  }
}
</style>
